import React, { useContext, useEffect } from 'react';

// Styles & Assets
import styles from './FilterPreconfigDialog.module.css';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Context
import FiltersContext from '../../../context/FiltersContext';

// Hooks
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';

// Components
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';
import RowButtonsFilter from '../../PatientsPage/RowButtonsFilter/RowButtonsFilter';

// Interfaces
import { Pathology } from '../../../interfaces/Preconfigurations';
interface Props {
    defaultIDs: number[]
    defaultProfileIDs: number[]
    modalShow: React.Dispatch<React.SetStateAction<boolean>>,
    setFilterBallActive: (isActive: boolean) => void
    handleConfirm: (selectedIDs: number[], selectedProfileIDs: number[]) => void,
}
const FilterPreconfigDialog: React.FC<Props> = ({ defaultIDs, defaultProfileIDs, modalShow, setFilterBallActive, handleConfirm }) => {

    const { t } = useTranslation();

    const { profiles } = useContext(FiltersContext);

    const { sendRequest } = useHttp<Pathology[]>();

    const [pathologies, setPathologies] = useState<Pathology[]>([]);

    const [selectedProfileIDs, setSelectedProfileIDs] = useState<number[]>(defaultProfileIDs);

    useEffect(() => {
        sendRequest({
            url: getEnvironmentApiUrl() + 'pathology/all',
            method: 'POST',
            body: { params: {}, filter: {} }
        }, (data) => setPathologies(data));
    }, [sendRequest]);

    const [selectedIDs, setSelectedIDs] = useState<number[]>(defaultIDs);

    const handleClickFilter = (id: number) => {
        setSelectedIDs(oldFilters => {
            const newFilters = [...oldFilters];
            return (newFilters.includes(id)) ?
                newFilters.filter(oldID => oldID !== id)
                : [...newFilters, id];
        });
    };

    const handleClickProfile = (id: number) => {
        setSelectedProfileIDs(oldFilters => {
            const newFilters = [...oldFilters];
            return (newFilters.includes(id)) ?
                newFilters.filter(oldID => oldID !== id)
                : [...newFilters, id];
        });
    };

    const handleConfirmFilter = () => {
        setFilterBallActive(selectedIDs.length > 0 || selectedProfileIDs.length > 0);
        handleConfirm(selectedIDs, selectedProfileIDs);
        modalShow(false);
    };


    return (
        <div className={`dialog ${styles.dialog}`}>
            <h1 className='dialogTitle'>{t('filter')} {t('preconfigurations').toLocaleLowerCase()}</h1>
            <RowButtonsFilter
                text={t('tag')}
                currentFilters={selectedIDs}
                handleClick={handleClickFilter}
                content={pathologies.map(pathology => ({ id: pathology.id, content: pathology.name }))}
                gridDisplay
            />
            <RowButtonsFilter
                text={t('environment')}
                currentFilters={selectedProfileIDs}
                handleClick={handleClickProfile}
                content={profiles.map(p => ({ id: p.id, content: p.name }))}
                gridDisplay
            />
            <CancelConfirmButtons onCancel={() => modalShow(false)} onConfirm={handleConfirmFilter} />
        </div>
    );
};

export default FilterPreconfigDialog;